<template>
  <b-row class="section-5" v-show="zoomGraphValue === ''" v-if="!useDualRow">
    <b-colxx md="12" lg="12" v-bind:xl="valueSizeOnXL" class="pl-0 pb-10">
      <b-card class="custom-card white-bg card-height-top">
        <b-card-header>
          <div class="card-text-strong">Average Time to Entry Completed</div>
        </b-card-header>
        <div class="data-card-center" v-if="avgTimeStatusData && avgTimeStatusData.avgEntryCompleted">
          <div class="number-text">
            {{ avgTimeStatusData.avgEntryCompleted.d }}
            <span class="small-text-custom">{{ avgTimeStatusData.avgEntryCompleted.d != 1 ? "days" : "day" }}</span>
            {{ avgTimeStatusData.avgEntryCompleted.h }}<span class="small-text-custom">hrs</span>
          </div>
          <div class="container-label">
            <div class="flex-column">Longest Activity</div>
            <div class="flex-column-value add-tooltip">
              {{ avgTimeStatusData.longestEntryCompleted }}
            </div>
            <div class="custom-tooltip hidden-text-custom text-right-value">
              <div>{{ avgTimeStatusData.longestEntryCompleted }}</div>
            </div>
          </div>
        </div>
        <div v-else class="align-center">
          <div class="card-text-title no-data" v-if="dataLoaded">
            No Data In
          </div>
          <!-- <div class="card-text-title no-data" v-else><i class="fa fa-spinner fa-spin loaderStyle"></i></div> -->
        </div>
      </b-card>
    </b-colxx>
    <b-colxx md="12" lg="12" v-bind:xl="valueSizeOnXL" class="pl-0 pb-10">
      <b-card class="custom-card white-bg card-height-top">
        <b-card-header>
          <div class="card-text-strong">Average Time to Approved</div>
        </b-card-header>
        <div class="data-card-center" v-if="avgTimeStatusData && avgTimeStatusData.avgApproved">
          <div class="number-text">
            {{ avgTimeStatusData.avgApproved.d }}
            <span class="small-text-custom">{{ avgTimeStatusData.avgApproved.d != 1 ? "days" : "day" }}</span>
            {{ avgTimeStatusData.avgApproved.h }}<span class="small-text-custom">hrs</span>
          </div>
          <div class="container-label">
            <div class="flex-column">Longest Activity</div>
            <div class="flex-column-value add-tooltip">
              {{ avgTimeStatusData.longestApproved }}
            </div>
            <div class="custom-tooltip hidden-text-custom text-right-value">
              <div>{{ avgTimeStatusData.longestApproved }}</div>
            </div>
          </div>
        </div>
        <div v-else class="align-center">
          <div class="card-text-title no-data" v-if="dataLoaded">
            No Data In
          </div>
          <!-- <div class="card-text-title no-data" v-else><i class="fa fa-spinner fa-spin loaderStyle"></i></div> -->
        </div>
      </b-card>
    </b-colxx>
    <b-colxx md="12" lg="12" v-bind:xl="valueSizeOnXL" class="pl-0 pb-10">
      <b-card class="custom-card white-bg card-4 card-height-bottom">
        <b-card-header>
          <div class="card-text-strong">Average Time to Verified</div>
        </b-card-header>
        <div class="data-card-center" v-if="avgTimeStatusData && avgTimeStatusData.avgVerified">
          <div class="number-text">
            {{ avgTimeStatusData.avgVerified.d }}
            <span class="small-text-custom">{{ avgTimeStatusData.avgVerified.d != 1 ? "days" : "day" }}</span>
            {{ avgTimeStatusData.avgVerified.h }}<span class="small-text-custom">hrs</span>
          </div>
          <div class="container-label">
            <div class="flex-column">Longest Activity</div>
            <div class="flex-column-value add-tooltip">
              {{ avgTimeStatusData.longestVerified }}
            </div>
            <div class="custom-tooltip hidden-text-custom text-right-value">
              <div>{{ avgTimeStatusData.longestVerified }}</div>
            </div>
          </div>
        </div>
        <div v-else class="align-center">
          <div class="card-text-title no-data card-no-data" v-if="dataLoaded">
            No Data In
          </div>
          <!-- <div class="card-text-title no-data" v-else><i class="fa fa-spinner fa-spin loaderStyle"></i></div> -->
        </div>
      </b-card>
    </b-colxx>
    <b-colxx md="12" lg="12" v-bind:xl="valueSizeOnXL" class="pl-0 pb-10 pr-0">
      <b-card class="custom-card white-bg card-4 card-height-bottom">
        <b-card-header>
          <div class="card-text-strong">Average Time to Signed Off</div>
        </b-card-header>
        <div class="data-card-center" v-if="avgTimeStatusData && avgTimeStatusData.avgSignedOff">
          <div class="number-text">
            {{ avgTimeStatusData.avgSignedOff.d }}
            <span class="small-text-custom">{{ avgTimeStatusData.avgSignedOff.d != 1 ? "days" : "day" }}</span>
            {{ avgTimeStatusData.avgSignedOff.h }}<span class="small-text-custom">hrs</span>
          </div>
          <div class="container-label">
            <div class="flex-column">Longest Activity</div>
            <div class="flex-column-value add-tooltip">
              {{ avgTimeStatusData.longestSignedOff }}
            </div>
            <div class="custom-tooltip hidden-text-custom text-right-value">
              <div>{{ avgTimeStatusData.longestSignedOff }}</div>
            </div>
          </div>
        </div>
        <div v-else class="align-center">
          <div class="card-text-title no-data card-no-data" v-if="dataLoaded">
            No Data In
          </div>
          <!-- <div class="card-text-title no-data" v-else><i class="fa fa-spinner fa-spin loaderStyle"></i></div> -->
        </div>
      </b-card>
    </b-colxx>
  </b-row>
  <b-colxx xl="6" lg="6" md="12" class="pl-0 pb-0 pr-0" v-show="zoomGraphValue === ''" v-else>
    <b-row class="section-6">
      <b-colxx md="12" lg="12" v-bind:xl="valueSizeOnXL" class="pl-0 pb-29 pr-27">
        <b-card class="custom-card white-bg card-height-top">
          <b-card-header>
            <div class="card-text-strong">Average Time to Entry Completed</div>
          </b-card-header>
          <div class="data-card-center" v-if="avgTimeStatusData && avgTimeStatusData.avgEntryCompleted">
            <div class="number-text">
              {{ avgTimeStatusData.avgEntryCompleted.d }}
              <span class="small-text-custom">{{ avgTimeStatusData.avgEntryCompleted.d != 1 ? "days" : "day" }}</span>
              {{ avgTimeStatusData.avgEntryCompleted.h }}<span class="small-text-custom">hrs</span>
            </div>
            <div class="container-label">
              <div class="flex-column">Longest Activity</div>
              <div class="flex-column-value add-tooltip">
                {{ avgTimeStatusData.longestEntryCompleted }}
              </div>
              <div class="custom-tooltip hidden-text-custom text-right-value">
                <div>{{ avgTimeStatusData.longestEntryCompleted }}</div>
              </div>
            </div>
          </div>
          <div v-else class="align-center">
            <div class="card-text-title no-data" v-if="dataLoaded">
              No Data In
            </div>
            <!-- <div class="card-text-title no-data" v-else><i class="fa fa-spinner fa-spin loaderStyle"></i></div> -->
          </div>
        </b-card>
      </b-colxx>

      <b-colxx md="12" lg="12" v-bind:xl="valueSizeOnXL" class="pl-0 pb-10">
        <b-card class="custom-card white-bg card-height-top">
          <b-card-header>
            <div class="card-text-strong">Average Time to Approved</div>
          </b-card-header>
          <div class="data-card-center" v-if="avgTimeStatusData && avgTimeStatusData.avgApproved">
            <div class="number-text">
              {{ avgTimeStatusData.avgApproved.d }}
              <span class="small-text-custom">{{ avgTimeStatusData.avgApproved.d != 1 ? "days" : "day" }}</span>
              {{ avgTimeStatusData.avgApproved.h }}<span class="small-text-custom">hrs</span>
            </div>
            <div class="container-label">
              <div class="flex-column">Longest Activity</div>
              <div class="flex-column-value add-tooltip">
                {{ avgTimeStatusData.longestApproved }}
              </div>
              <div class="custom-tooltip hidden-text-custom text-right-value">
                <div>{{ avgTimeStatusData.longestApproved }}</div>
              </div>
            </div>
          </div>
          <div v-else class="align-center">
            <div class="card-text-title no-data" v-if="dataLoaded">
              No Data In
            </div>
            <!-- <div class="card-text-title no-data" v-else><i class="fa fa-spinner fa-spin loaderStyle"></i></div> -->
          </div>
        </b-card>
      </b-colxx>
    </b-row>
    <b-row class="section-6">
      <b-colxx md="12" lg="12" v-bind:xl="valueSizeOnXL" class="pl-0 pb-30 pr-27">
        <b-card class="custom-card white-bg card-height-bottom">
          <b-card-header>
            <div class="card-text-strong">Average Time to Verified</div>
          </b-card-header>
          <div class="data-card-center" v-if="avgTimeStatusData && avgTimeStatusData.avgVerified">
            <div class="number-text">
              {{ avgTimeStatusData.avgVerified.d }}
              <span class="small-text-custom">{{ avgTimeStatusData.avgVerified.d != 1 ? "days" : "day" }}</span>
              {{ avgTimeStatusData.avgVerified.h }}<span class="small-text-custom">hrs</span>
            </div>
            <div class="container-label">
              <div class="flex-column">Longest Activity</div>
              <div class="flex-column-value add-tooltip">
                {{ avgTimeStatusData.longestVerified }}
              </div>
              <div class="custom-tooltip hidden-text-custom text-right-value">
                <div>{{ avgTimeStatusData.longestVerified }}</div>
              </div>
            </div>
          </div>
          <div v-else class="align-center">
            <div class="card-text-title no-data card-no-data" v-if="dataLoaded">
              No Data In
            </div>
            <!-- <div class="card-text-title no-data" v-else><i class="fa fa-spinner fa-spin loaderStyle"></i></div> -->
          </div>
        </b-card>
      </b-colxx>

      <b-colxx md="12" lg="12" v-bind:xl="valueSizeOnXL" class="pl-0 pb-30">
        <b-card class="custom-card white-bg card-4 card-height-bottom">
          <b-card-header>
            <div class="card-text-strong">Average Time to Signed Off</div>
          </b-card-header>
          <div class="data-card-center" v-if="avgTimeStatusData && avgTimeStatusData.avgSignedOff">
            <div class="number-text">
              {{ avgTimeStatusData.avgSignedOff.d }}
              <span class="small-text-custom">{{ avgTimeStatusData.avgSignedOff.d != 1 ? "days" : "day" }}</span>
              {{ avgTimeStatusData.avgSignedOff.h }}<span class="small-text-custom">hrs</span>
            </div>
            <div class="container-label">
              <div class="flex-column">Longest Activity</div>
              <div class="flex-column-value add-tooltip">
                {{ avgTimeStatusData.longestSignedOff }}
              </div>
              <div class="custom-tooltip hidden-text-custom text-right-value">
                <div>{{ avgTimeStatusData.longestSignedOff }}</div>
              </div>
            </div>
          </div>
          <div v-else class="align-center">
            <div class="card-text-title no-data card-no-data" v-if="dataLoaded">
              No Data In
            </div>
            <!-- <div class="card-text-title no-data" v-else><i class="fa fa-spinner fa-spin loaderStyle"></i></div> -->
          </div>
        </b-card>
      </b-colxx>
    </b-row>
  </b-colxx>
</template>

<script>
import * as dManagement from "@/services/visualization/new-data-management";

export default {
  name: "average-time-cards",
  props: {
    useDualRow: { type: Boolean, default: false },
    zoomGraphValue: { type: String, default: "" },
    activitiesRaw: { type: Object },
    filterTriggered: { type: Boolean },
    dataLoaded: { type: Boolean, default: false },
    sitesSelected: { type: Array, default: () => ["all"] },
    countrySelected: { default: () => "all" },
    valueSizeOnXL: { type: String, default: "3" }
  },
  data() {
    return {
      avgTimeStatusData: null
    };
  },
  watch: {
    activitiesRaw: function(newValue) {
      this.avgTimeStatusData = newValue ? dManagement.GET_AVERAGE_TIME_ACTIVITY_STATUS(newValue, this.countrySelected, this.sitesSelected) : null;
    },
    filterTriggered: function() {
      this.avgTimeStatusData = dManagement.GET_AVERAGE_TIME_ACTIVITY_STATUS(this.activitiesRaw, this.countrySelected, this.sitesSelected);
    }
  }
};
</script>

<style scoped>
.card-height-top {
  height: 135px !important ;
}
.card-height-bottom {
  height: 135px !important;
}
.card-no-data {
  height: 100px !important;
}
</style>
